<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="modalBody">
      <div class="searchPatient">
        <form class="w-100" @submit.stop.prevent="getPatientsV2()">
          <div class="SearchPti">
            <div class="bolderTxt hiddenDiv">
              <div>Nombre del paciente:</div>
            </div>
            <div class="inputBusqueda">
              <b-form-input
                            v-model="nombreCompleto"
                            placeholder="Ingresa el nombre completo"
                            type="text"
                            v-b-tooltip.hover
                            v-on:keyup.enter="getPatientsV2()"
              ></b-form-input>
            </div>
            <b-button variant="primary" type="submit"
            >
              <b-icon icon="search"></b-icon
              >
            </b-button>
          </div>
        </form>
      </div>
      <br/>
      <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="false"
      ></loading>
      <span class="tablePatients">
        <h4>Resultados de la Búsqueda</h4>
        <br/>
        <b-table
            thead-tr-class="columnas"
            :items="patientTable"
            :fields="encabezados"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            class="parrafos"
            responsive
        >
          <template v-slot:cell(id)="row">
            {{ row.item.id }}
          </template>

          <template v-slot:cell(telefono)="row">

            <span v-if="row.item.telefono !== null && row.item.telefono !== 'null'">
              {{ row.item.telefono }}
            </span>

            <span v-if="row.item.telefonoCasa !== null && row.item.telefonoCasa !== 'null'">
              <br/>
              {{ row.item.telefonoCasa }}
            </span>
            <span v-if="row.item.telefonoTrabajo !== null && row.item.telefonoTrabajo !== 'null'">
              <br/>
              {{ row.item.telefonoTrabajo }}
            </span>
          </template>

          <template v-slot:cell(correo)="row">

            <span v-if="row.item.correo !== null && row.item.correo !== 'null'">
              {{ row.item.correo }}
            </span>
          </template>

          <template v-slot:cell(name)="row">
            <router-link
                :id="'unificacion'+ row.item.id"
                v-if="$localStorageService.can('CA_03_menu')"
                :to="{ name: 'paciente', params: { id: row.item.id } }"

            >
              <div class="spanCien">
                <span
                      v-b-tooltip.hover.top="'Es un paciente unificado.'"
                      v-if="row.item.estatusPacienteColorDTO != null && row.item.pacienteUnificado"
                      :style="'color:' + row.item.estatusPacienteColorDTO.color"
                  >
                  {{ row.item.name }}
                </span>
                <span
                    v-else-if="row.item.estatusPacienteColorDTO != null"
                    :style="'color:' + row.item.estatusPacienteColorDTO.color"
                >
                  {{ row.item.name }}
                </span>
                <span v-else style="color: #000000">
                  {{ row.item.name }}
                </span>
              </div>
            </router-link>
            <span v-else>
              <span
                  v-if="row.item.estatusPacienteColorDTO != null"
                  :style="'color:' + row.item.estatusPacienteColorDTO.color"
              >
                {{ row.item.name }}
              </span>
              <span v-else style="color: #000000">
                {{ row.item.name }}
              </span>
            </span>
            <!--<b-popover v-if="row.item.pacienteUnificado" :target="'unificacion'+ row.item.id" triggers="hover focus" placement="top">
            Es un paciente unificado.
          </b-popover>-->
          </template>



          <template v-slot:cell(saldo)="row">
            <span>{{ row.item.saldo | moneda }}</span>
          </template>
          <template v-slot:cell(plan)="row">
            <span v-for="plan in row.item.plan" :key="plan.Id" :value="plan.Id">
              {{ plan.nombre }}
            </span>
            <span v-if="row.item.plan.length == 0"> NO APLICA </span>
          </template>
          <template v-slot:cell(lastDate)="row">
            {{ row.item.lastDate }}
          </template>
          <template v-slot:cell(proxDate)="row">
            {{ row.item.proxDate }}
          </template>
          <template v-slot:cell(adeudo)="row">
            <span style="color: #ff0000" v-if="row.item.adeudo > 0">{{
                row.item.adeudo | moneda
              }}</span>
            <span v-else>{{ row.item.adeudo | moneda }}</span>
          </template>
          <template v-slot:cell(fechaUltimaCita)="row">
            <span v-if="row.item.fechaUltimaCita != null">
              {{ row.item.fechaUltimaCita | formatoFechaCorta }}
            </span>
            <span v-else>
              No hay última cita
            </span>
          </template>
          <template v-slot:cell(clinica)="row">
            <span v-if="row.item.clinica != null">
              {{ row.item.clinica}}
            </span>
            <span v-else>
              N/A
            </span>
          </template>
          <template v-slot:cell(fechaProximaCita)="row">
            <span v-if="row.item.fechaProximaCita != null">
              {{ row.item.fechaProximaCita | formatoFechaCorta }}
            </span>
            <span v-else>
              No hay próxima cita
            </span>
          </template>
          <template v-slot:cell(planes)="row">
                <b-button size="sm" style="font-size: small" @click="row.toggleDetails" class="btn-info botonCentrado" >
                   <span v-if="!row.detailsShowing" title="Mostar Detalle">
                      <em class="ojo_svg icon-boton" style=" position: relative; left: 0.5px;"></em>
                   </span>
                  <span v-else title="Ocultar Detalle">
                      <em class="close_x_svg icon-boton" style=" position: relative; left: 1.5px; height: 9px !important; margin: 4px !important;"></em>
                  </span>
                </b-button>
          </template>
          <template #row-details="row">
        <b-card class="text-left" style="border-radius: 1.25rem; border-color: #1dbdd5;">
          <span v-if="row.item.planes.length > 0">
              <h6 style="font-weight: bold; color: var(--color-dentalia);">Planes del Paciente</h6>
               <ul v-for="(item, index) in row.item.planes" :key="item.nombre">
                 <li><strong style="font-weight: bold; color: var(--color-dentalia);">{{index+1}}.- </strong>{{item.nombre}}</li>
               </ul>
          </span>
          <span v-else>
             <b-alert show variant="info">No hay Planes</b-alert>
          </span>
        </b-card>
      </template>
        </b-table>
        <b-pagination
            v-if="patientTable.length > 15"
            align="center"
            v-model="paginaActual"
            :total-rows="patientTable.length"
            :per-page="registrosPorPagina"
        ></b-pagination>
      </span>
    </div>
  </div>
</template>

<script>
//components
import miniToastr from "mini-toastr"; //ES6

export default {
  name: "Patients",
  props: {
    msg: String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    patientTable: [],
    patients: [],
    busquedaAvanzada: false,
    pacienteSelect: null,
    patientInput: null,
    encabezados: [
      {key: "id", label: "Id", sortable: true},
      {key: "name", label: "Nombre del Paciente", sortable: true},
      {key: "fechaNacimientoCompleta", label: "Fecha de nacimiento", sortable: true},
      {key: "adeudo", label: "Adeudo", sortable: true},
      {key: "saldo", label: "Saldo", sortable: true},
      {key: "telefono", label: "Teléfono", sortable: true},
      {key: "correo", label: "Correo", sortable: true},
      {key: "fechaUltimaCita", label: "Última Cita", sortable: true},
      {key: "clinica", label: "Clínica", sortable: true},
      {key: "fechaProximaCita", label: "Próxima Cita", sortable: true},
      {key: "planes", label: "Planes", sortable: true},
    ],
    registrosPorPagina: 15,
    paginaActual: 1,
    loading: false,
    nombreCompleto: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: ""
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    getPatients() {
      this.loading = true;
      /*Usa un servicio  de archivo   ### ServAbiertoPacientesControlador     ###        */
      /*if (searchTerm != undefined && searchTerm.length > 3) {
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();


        this.$http
            .get(
                this.$api +
                "paciente/perfiles/obtenerDatosPaciente?nombrePaciente=" +
                inputTxt + "&busquedaAvanzada=" + this.busquedaAvanzada,
                {}
            )
            .then((response) => {
              if (response.status === 200) {
                this.patientTable = [];
                if (Array.isArray(response.data.data) == true) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.id))
                  ).map((id) => {
                    return response.data.data.find((a) => a.id === id);
                  });
                  uniqueAddresses.map((elementDos) => {
                    var data = {
                      id: elementDos.id,
                      name: elementDos.nombre,
                      fechaNacimientoCompleta: elementDos.fechaNacimientoCompleta,
                      adeudo: elementDos.adeudo,
                      saldo: elementDos.saldo,
                      telefono: elementDos.telefono,
                      correo: elementDos.correo,
                      fechaProximaCita: elementDos.fechaProximaCita,
                      estatusPacienteColorDTO: elementDos.estatusPacienteColorDTO,
                      fechaUltimaCita: elementDos.fechaUltimaCita,
                      telefonoCasa: elementDos.telefonoCasa,
                      telefonoTrabajo: elementDos.telefonoTrabajo,
                      pacienteUnificado: elementDos.pacienteUnificado,
                    };
                    this.patientTable.push(data);
                    return data;
                  });

                  if (Array.isArray(this.patientTable) == true) {
                    this.patientTable.sort(function (a, b) {
                      if (a.id > b.id) {
                        return 1;
                      }
                      if (a.id < b.id) {
                        return -1;
                      }
                      return 0;
                    });
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              this.patientTable = [];
              console.error(error);
              this.loading = false;
            })
            .finally(() => (this.loading = false));
      } else {
        this.loading = false;
      }*/
    },
    getPatientsV2() {
      this.loading = true;
       this.paginaActual = 1;
      if ((this.nombreCompleto != undefined && this.nombreCompleto.length >= 3) || (this.nombre != undefined && this.nombre.length >= 3) || (this.apellidoPaterno != undefined && this.apellidoPaterno.length >= 3) || (this.apellidoMaterno != undefined && this.apellidoMaterno.length >= 3)) {

        const params= {
          nombrePaciente: this.nombreCompleto,
          nombre: this.nombre.trim(),
          apellidoPaterno: this.apellidoPaterno.trim(),
          apellidoMaterno: this.apellidoMaterno.trim(),
          busquedaAvanzada: this.busquedaAvanzada
        }

        this.$http
            .post(
                this.$api +
                "paciente/perfiles/obtenerDatosPaciente", params
            )
            .then((response) => {
              if (response.status === 200) {
                this.patientTable = [];
                if (Array.isArray(response.data.data) == true) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.id))
                  ).map((id) => {
                    return response.data.data.find((a) => a.id === id);
                  });
                  uniqueAddresses.map((elementDos) => {
                    var data = {
                      id: elementDos.id,
                      name: elementDos.nombre,
                      fechaNacimientoCompleta: elementDos.fechaNacimientoCompleta,
                      adeudo: elementDos.adeudo,
                      saldo: elementDos.saldo,
                      telefono: elementDos.telefono,
                      correo: elementDos.correo,
                      fechaProximaCita: elementDos.fechaProximaCita,
                      estatusPacienteColorDTO: elementDos.estatusPacienteColorDTO,
                      fechaUltimaCita: elementDos.fechaUltimaCita,
                      telefonoCasa: elementDos.telefonoCasa,
                      telefonoTrabajo: elementDos.telefonoTrabajo,
                      pacienteUnificado: elementDos.pacienteUnificado,
                      planes: elementDos.planes,
                      clinica: elementDos.clinica
                    };
                    this.patientTable.push(data);
                    return data;
                  });

                  if (Array.isArray(this.patientTable) == true) {
                    this.patientTable.sort(function (a, b) {
                      if (a.id > b.id) {
                        return 1;
                      }
                      if (a.id < b.id) {
                        return -1;
                      }
                      return 0;
                    });
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              this.patientTable = [];
              console.error(error);
              this.loading = false;
            })
            .finally(() => (this.loading = false));
      } else {
        this.loading = false;
      }
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character

      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
};
</script>

<style scoped>
.template {
  width: 100%;
}

.colorHeader {
  background-color: #f6f6f6;
}

.headerTxt {
  font-weight: bold;
}

.SearchPti {
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.inputBusqueda {
  width: 70%;
}

.swal2-title {
  font-size: 20px !important;
}

.mginTop {
  margin-top: 30px !important;
}

.searchPatient {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px 0 0 0;
  border: 1px solid #ddd;
  background-color: white !important;
  padding-left: 10px;
}

.BuscarTitle {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-size: 15px;
  font-weight: bolder;
  display: flex;
  padding-left: 25px;
  background-color: white !important;
  border-radius: 3px 0 0 0;
  border: 1px solid #ddd;
}

.searchicon {
  color: white !important;
  font-size: 16px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bolderTxt {
  font-size: 14px;
  font-weight: bolder;
  width: 20%;
  margin-left: 15px;
}

.spanCien {
  width: 100% !important;
  padding-top: 5px;
  padding-bottom: 5px;
}

.inputFlex {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.inputDiv {
  margin-top: 10px;
  width: 90%;
}
@media (max-width: 700px){
  .searchPatient {
    height: 40vw !important;
  }
  .input-buscador{
    margin: 1vw;
  }
}

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
  border-radius: 20px;
}
.icon-boton{
  -webkit-filter: brightness(0) invert(1);
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
  position: relative;
  left: 0.5px;
}
.botonCentrado{
  padding-bottom: 4px;
  padding-top: 1px;
  padding-left: 2px;
  padding-right: 4px;
}
</style>
